import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../../../common/modal/Modal';
import DeleteItineraryFoodForm from './DeleteItineraryFoodForm';
import { deleteItineraryAdditionalFood } from '../../../../../actions/itinerary/ItineraryAdditionalFood';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { ITINERARY_ADDITIONAL_FOOD_ENDPOINT } from '../../../../../config/endpoints';
import { DELETE } from '../../../../../config/permissions';

const DeleteItineraryAdditionalFoodButton = ({
  dispatchDeleteItineraryAdditionalFood,
  itineraryId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const closeModal = () => setShowModal(false);

  const onModalSubmit = async (formValues) => {
    const { supplierId } = formValues;

    const normalizedSupplierId = supplierId
      ? supplierId.value || supplierId
      : null;

    if (!normalizedSupplierId) return;

    const response = await dispatchDeleteItineraryAdditionalFood(
      itineraryId,
      normalizedSupplierId,
    );

    if (response) {
      closeModal();
    }
  };

  const openModal = () => setShowModal(true);

  const buildModalBody = () => {
    const newModalBody = (
      <DeleteItineraryFoodForm
        onCancel={closeModal}
        handleProcess={onModalSubmit}
      />
    );

    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal
        show={showModal}
        title="Eliminar Alimentación Adicional por Proveedor"
        body={modalBody}
        size="md"
      />

      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar Alimentación Adicional
      </Button>
    </>
  );
};

DeleteItineraryAdditionalFoodButton.propTypes = {
  dispatchDeleteItineraryAdditionalFood: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

DeleteItineraryAdditionalFoodButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteItineraryAdditionalFood: deleteItineraryAdditionalFood,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(DeleteItineraryAdditionalFoodButton);

export default withEndpointAuthorization({
  url: ITINERARY_ADDITIONAL_FOOD_ENDPOINT,
  permissionType: DELETE,
})(connectedComponent);
